// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @08.08.2019 07:18:42
import { Guid, GuidTools } from '@models/guid';
import * as SagaBase from '../../SagaBase';
import { SagaObject } from '../../SagaBase/SagaObject';

export abstract class Crew_abstract extends SagaObject {
  static $t: string = 'SagaSchema.Crew';
  $t: string = 'SagaSchema.Crew';

  public static GetMembers(): string[] {
    return [
      'CallCardID',
      'Status',
      'ActivityUid',
      'ActivityStatus',
      'Archived',
      'Name',
      'StartDateUTC',
      'EndDateUTC',
      'InactivePeriodsString',
      'LeaderID',
      'GpsCarrierID',
      'Break1',
      'Break2',
      'Break1StartUTC',
      'Break1EndUTC',
      'Break2StartUTC',
      'Break2EndUTC',
      'ResourceUpdateVersion',
      'TaskUpdateVersion'
    ].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return Crew_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    this.StartDateUTC = this.StartDateUTC && new Date(this.StartDateUTC);
    this.EndDateUTC = this.EndDateUTC && new Date(this.EndDateUTC);

    this.Break1StartUTC = this.Break1StartUTC && new Date(this.Break1StartUTC);
    this.Break1EndUTC = this.Break1EndUTC && new Date(this.Break1EndUTC);

    this.Break2StartUTC = this.Break2StartUTC && new Date(this.Break2StartUTC);
    this.Break2EndUTC = this.Break2EndUTC && new Date(this.Break2EndUTC);

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return ['SagaSchema.CrewResource', 'SagaSchema.CrewTask', 'SagaSchema.ResourcePosition'];
  }

  private _components = {};

  component<T>(obj: any): Array<T> {
    let name: string;

    if (typeof obj === 'string') name = <string>obj;
    else if (obj.$t) name = obj.$t;
    else return [];

    if (!this._components[name]) {
      if (this.components().indexOf(name) >= 0) this._components[name] = [];
    }
    return this._components[name];
  }

  public add(obj: any): void {
    var compList = this.component<any>(obj.$t);

    // Only list elements can be added.
    for (var i = 0; i < compList.length; i++)
      if (compList[i].ObjId == obj.ObjId) {
        compList[i] = obj;
        return;
      }
    compList.push(obj);
    obj.ParentObjId = (<any>this).ObjId;
  }

  public remove(obj: any): void {
    if (obj == null) return;

    var compObj = <Array<any>>this.component<any>(obj.$t);
    if (compObj != null) {
      var index = compObj.indexOf(obj);
      if (index >= 0) compObj.splice(index, 1);
    }
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public CallCardID: Guid = GuidTools.Empty;
  public Status: number = 0;
  public ActivityUid: Guid = GuidTools.Empty;
  public ActivityStatus: SagaBase.Interfaces.ActivityStatusType = SagaBase.Interfaces.ActivityStatusType.Available;
  public Archived: boolean = false;
  public Name: string;
  public StartDateUTC: Date = new Date();
  public EndDateUTC: Date = new Date();
  public InactivePeriodsString: string;
  public LeaderID: Guid = GuidTools.Empty;
  public GpsCarrierID: Guid = GuidTools.Empty;
  public Break1: string;
  public Break2: string;
  public Break1StartUTC: Date = new Date();
  public Break1EndUTC: Date = new Date();
  public Break2StartUTC: Date = new Date();
  public Break2EndUTC: Date = new Date();

  public ResourceUpdateVersion: number = 0;
  public TaskUpdateVersion: number = 0;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
